module.exports = __webpack_public_path__ + "media/images/official/special_double_life_point_homes-1ef8d08a32156e5d4549919a998a4fc8.jpg";